import ValuesIconDefault from "./ValuesIconDefault";
import ValuesIconSectionII from "./ValuesIconSectionII";
import ValuesIconSpecialFeatures from "./ValuesIconSpecialFeatures";

export default function ValuesIcon({
    parameterType,
    parameter_details_def,
    allValues,
    tooltipRef,
    label,
    associatedOutputParamValue,
}) {
    if (allValues?.parameter === "special_property_features_values") {
        return <ValuesIconSpecialFeatures tooltipRef={tooltipRef} />;
    }
    if (allValues?.parameter === "section_ii_entry_value") {
        return <ValuesIconSectionII tooltipRef={tooltipRef} />;
    }
    if (parameterType !== "AVM") {
        return null;
    }
    return (
        <ValuesIconDefault
            allValues={allValues}
            parameter_details_def={parameter_details_def}
            tooltipRef={tooltipRef}
            label={label}
            associatedOutputParamValue={associatedOutputParamValue}
        />
    );
}
